<template>
  <div id="layJournalList">
    <div class="left_Title">
      <p>
        <i class="iconfont iconjieguo"></i>
        <span class="aqt_lang_mn titlefont">{{ $t('m.seareturn') +'&nbsp;'+ '(' + total + ')' |U2M }}</span>
      </p>
      <p></p>
    </div>
    <div v-if="!isNo" class="list_Content aqt_no_su" ref="Content_Width">
      <div class="aqt_list_lists_one" v-for="(item,index) in list" :key="index" @click="getDetail(item.periodical_id,item.isxq)">
        <div class="aqt_top aqt_ce_ve">
          <img v-lazy="item.imgm?$webcrypto.get(item.imgm):''" alt/>
          <div class="label" v-show="item.annexcount>0">PDF</div>
        </div>
        <div class="aqt_center">
          <!-- 蒙语标题 -->
          <div class="aqt_title">
            <p v-if="item.titlelang&&item.titlelang.mn" class="titlefont aqt_lang_mn"
               v-html="U2M(item.titlelang.mn)"></p>
            <p v-else class="titlefont aqt_su"
               v-html="U2M(item.titlelang?item.titlelang.zh?item.titlelang.zh:'':'')"></p>
          </div>
          <div class="aqt_zhengzhuang">
            <img src="../../assets/images/pubulish.png" alt/>
            <p class="aqt_lang_mn contentfont contentfonts1">{{ $t('m.qishu')|U2M }} : {{item.number}}</p>
          </div>
          <div class="aqt_zhengzhuang">
            <img src="../../assets/images/info_host_unitlang.png" alt/>
            <p class="contentfont contentfonts1 aqt_lang_mn">{{ $t('m.Sponsor')|U2M }} : {{
                item.host_unitlang ? item.host_unitlang.mn ? item.host_unitlang.mn : item.host_unitlang.zh : $t('m.noData') | U2M
              }}</p>
          </div>
          <div class="aqt_zhengzhuang">
            <img src="../../assets/images/info_people.png" alt/>
            <p class="contentfont contentfonts1 aqt_lang_mn">{{ $t('m.chief_editor')|U2M }} : {{
                item.editorlang ? item.editorlang.mn ? item.editorlang.mn : item.editorlang.zh : $t('m.noData') | U2M
              }}</p>
          </div>
        </div>
        <div class="aqt_bottom_img">
          <img src="@/assets/images/detail_bottom.png">
        </div>
      </div>
    </div>
    <div class="page">
      <PageMn v-if="!isNo" :total="total" :current="current_page"
              :pageSize="per_page" @getPager="getPager">
        </PageMn>
      <!-- <Page v-if="!isNo"   :total="total" :current="current_page"
            :page-size="per_page"
            @on-change="getPager"/> -->
    </div>
    <div v-if="isNo&&!list.length" class="nomassage">
      <p class="aqt_lang_mn titlefont">{{ $t('m.noData') | U2M }}</p>
    </div>
    <!--    加载动画-->
    <AqtSpin v-if="isSpin"></AqtSpin>
  </div>
</template>
<script>
export default {
  data() {
    return {
      total: 0,
      current_page: 1,
      per_page: 0,
      list: [],
      isNo: false,
      booksSearch: {
        member_id:'',
        library_id: '',
        page: 1,
        magazine_id: '',
        per_page: '',

        title: '',//书名
        type:'',//all 全部期刊列表 全部杂志入口  one树状杂志 当前馆藏杂志
        keyword:'',//关键词
        issn:'',
        editor:'',//主编
        deputy_editor:'',//副主编
        keymn:'',//首字母
        magazineclass_id:'',//分类id
      },
      isSpin: false,
    }
  },
  methods: {
    /******************************************
     *
     *分页器
     *
     *****************************************/
    getPager(page) {
      let that = this
      that.list = []
      that.booksSearch.page = page
      that.getList()
    },
    getList() {
      let that = this
      that.isSpin = true
      that.list = []
      //保存用户搜索记录
      if(that.booksSearch.page==1){
        that.$store.commit('SET_PuserSearch', [JSON.stringify(that.booksSearch), that.$route.path, that.$route.meta.title, 4],)
        that.$store.dispatch('getHedcircle')
      }
      that.booksSearch.library_id = that.library_id
      that.booksSearch.member_id = that.member_id
      that.$httpsencrypt.post(`api/web/v3/periodical/newlistpc`, that.booksSearch)
          .then((val) => {
            if (val.code == 200 && val.data.length) {
              that.total = val.pages.total
              that.current_page = val.pages.current_page
              that.per_page = val.pages.per_page * 1

              if (that.booksSearch.title) {
                val.data.forEach((item) => {
                  var arr = item.titlelang.mn.split(" ");
                  arr.forEach((elem, index) => {
                    var strarr = that.booksSearch.title.split(' ')
                    strarr.forEach(it => {
                      if (it == '') {
                        return
                      }
                      var i = elem.indexOf(it.trim());

                      if (i > -1) {
                        var replacestr =
                            '<span style="color:var(--themeColor)!important;">' +
                            arr[index] +
                            "</span>";
                        arr[index] = replacestr;
                      }

                    })
                  });
                  item.titlelang.mn = arr.join(" ");
                });
              }

              that.list = val.data
              that.isSpin = false
              that.isNo = false
            } else {
              that.list = []
              that.isNo = true
              that.isSpin = false
              that.total = 0
            }

          }).catch(e => {
            that.list = []
            that.isNo = true
            that.isSpin = false
            that.total = 0
          }
      )
    },
    getDetail(id,isxq){
      let that = this
      if(isxq==0){
        that.$Message.warning(that.$t('m.no_permission'));
        return
      }
      let cond = {
        id:id
      }
      that.$emit('getToDeatils',cond,'JournalDetails')
    },

    //父组件调用请求数组
    ParentCom(val){
      let that = this
      that.isNo = false
      that.booksSearch.title=val.title
      that.booksSearch.magazine_id=val.magazine_id
      that.booksSearch.type=val.type
      that.booksSearch.keyword=val.keyword
      that.booksSearch.issn=val.issn
      that.booksSearch.editor=val.editor
      that.booksSearch.deputy_editor=val.deputy_editor
      that.booksSearch.keymn=val.keymn
      that.booksSearch.magazineclass_id=val.magazineclass_id
      that.getList()
    },

  },
  computed: {
    // 馆藏id
    library_id() {
      let vv = localStorage.getItem("theme_color") ? JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id : 28;
      return vv
    },
    // 用户id
    member_id() {
      let mm = localStorage.getItem("userInfoMemberId") ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : ''
      return mm
    },
  },
  mounted() {
    let that = this
    let kk = that.$refs.Content_Width.clientWidth / 120.2
    that.booksSearch.per_page = Math.floor(kk)
    that.booksSearch.page=1
  },
  created() {
    this.$emit('getWidth')
    let info={
      type: 2,
      path: this.$route.path,
      mark: '期刊列表',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  }

}
</script>
<style lang="less" scoped>
#layJournalList {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;

  .contentfonts1 {
    font-size: 1.6rem;
  }

  .nomassage {
    padding: 0 1rem;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    display: -ms-flexbox;
    display: flex;
    font-size: 2rem;
    color: #888888;
  }

  .left_Title {
    width: 54px;
    height: 100%;
    background: #ffffff;
    margin-right: 2px;
    padding-top: 27px;
    display: flex;
    justify-content: flex-end;

    p:nth-child(1) {
      width: 24px;
      color: var(--themeColor);
      font-size: 20px;
      line-height: 24px;

      i {
        font-size: 24px;
      }
    }

    p:nth-child(2) {
      width: 8px;
      height: 162px;
      background: var(--themeColor);
      margin-left: 10px;
    }
  }

  .list_Content {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    overflow-x: auto !important;
    overflow-y: hidden;

    .aqt_list_lists_one {
      width: 120px;
      height: 100%;
      background-color: #ffffff;
      margin-right: 0.2rem;
      cursor: pointer;

      .aqt_top {
        height: 127px;
        width: calc(100% - 16px);
        position: relative;
        margin: 8px auto 0;
        box-shadow: rgb(136, 136, 136) 1px 1px 6px;
        overflow: hidden;

        .label {
          line-height: 24px;
          height: 20px;
          height: 20px;
          background: red;
          color: #fff;
          font-size: 12px;
          position: absolute;
          right: 0;
          top: 0;
          z-index: 2;
          padding: 0 15px;
          -webkit-transform-origin: left bottom;
          -moz-transform-origin: left bottom;
          transform-origin: left bottom;
          -webkit-transform: translate(29.29%, -100%) rotate(45deg);
          -moz-transform: translate(29.29%, -100%) rotate(45deg);
          transform: translate(29.29%, -100%) rotate(45deg);
          text-indent: 0;
        }


        img {
          height: inherit;
          width: 100%;
          display: inline-flex;
        }

        img[lazy="loading"] {
          height: auto !important;
        }
      }

      .aqt_center {
        height: calc(100% - 177px);
        width: 100%;
        padding-top: 1rem;
        display: flex;

        .aqt_lang_mn1 {
          writing-mode: vertical-lr;
        }

        .aqt_title {
          width: 3.4rem;
          height: calc(100% - 1rem);
          color: #888888;
          font-size: 1.8rem;
          margin: 0 0.5rem;

          p {
            white-space: nowrap;
            -o-text-overflow: ellipsis;
            text-overflow: ellipsis;
            overflow: hidden;
            margin: 0 auto;
            height: 100%;
          }
        }

        .aqt_con {
          height: calc(100% - 1rem);
          color: #888888;
          font-size: 1.6rem;
          overflow: hidden;
          width: 5.6rem;
          line-height: 1.9rem;

          p {
            margin: 0 auto;
          }
        }

        .aqt_zhengzhuang {
          height: calc(100% - 3.4rem);
          width: calc(calc(100% - 3.4rem) / 2);
          color: #888888;
          font-size: 1.6rem;
          white-space: nowrap;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          overflow: hidden;
          line-height: 1.6rem;
          padding-top: 12px;

          img {
            width: 1.6rem;
            height: 1.6rem;
            margin-bottom: 0.5rem;
          }
        }
      }

      .aqt_bottom_img {
        width: 100%;
        height: 40px;

        img {
          width: 100%;
          height: auto;
        }
      }
    }
    .aqt_list_lists_one:hover {
      background: rgba(255, 255, 255, 0.3);

      .aqt_title {
        color: var(--themeColor);
      }

      .aqt_zhengzhuang {
        color: var(--themeColor);
      }

      .aqt_zhengzhuangTwo {
        color: var(--themeColor);
      }
    }
  }

  .list_Content::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }

  .list_Content::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .list_Content::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .page {
    width: 50px;
    height: 100%;
  }
}
</style>

